const state = {
  appstatus:{}
}

export default state
